// LegalPage — shared shell for all legal / contact page shells.
// Charcoal card body, bronze title, muted placeholder copy. Matches
// existing AuthCard aesthetic without pulling any new dependencies.
import { Link } from "react-router-dom";

export default function LegalPage({ title, testid, children, backTo = "/" }) {
  return (
    <div
      data-testid={testid}
      style={{
        minHeight: "100vh",
        background: "#0f0f0f",
        color: "#f7f7f7",
        padding: "40px 16px",
      }}
    >
      <div
        style={{
          maxWidth: 720,
          margin: "0 auto",
          background: "#1a1a1a",
          border: "1px solid #2a2a2a",
          borderRadius: 12,
          padding: "32px",
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              display: "inline-block",
              border: "3px solid #C9A86A",
              color: "#C9A86A",
              fontWeight: 900,
              fontSize: 18,
              letterSpacing: 2,
              padding: "4px 10px",
              background: "#000",
              marginRight: 10,
              verticalAlign: "middle",
            }}
          >CDI</div>
          <span
            style={{
              color: "#C9A86A",
              fontWeight: 700,
              letterSpacing: 1,
              fontSize: 18,
              verticalAlign: "middle",
            }}
          >Collectables</span>
        </div>

        <h1
          data-testid={`${testid}-title`}
          style={{
            color: "#f7f7f7",
            fontSize: 24,
            fontWeight: 700,
            marginBottom: 8,
            letterSpacing: "0.3px",
          }}
        >{title}</h1>

        <div
          data-testid={`${testid}-body`}
          style={{ color: "#c9c9c9", fontSize: 14, lineHeight: 1.6 }}
        >
          {children || (
            <p style={{ color: "#9a9a9a" }} data-testid={`${testid}-placeholder`}>
              Legal content coming soon.
            </p>
          )}
        </div>

        <div style={{ marginTop: 28, paddingTop: 20, borderTop: "1px solid #2a2a2a" }}>
          <Link
            to={backTo}
            data-testid={`${testid}-home`}
            style={{ color: "#C9A86A", fontSize: 13, textDecoration: "none" }}
          >← Back to app</Link>
        </div>
      </div>
    </div>
  );
}
